type MockMapType = {
  [endpoint: string]: {
    [command: string]: string;
  };
};

const mockMap: MockMapType = {
  '/clinical-data/episodes/02893bc6-6746-4375-b295-8ffef9227964': {
    get: 'https://run.mocky.io/v3/71377b60-e6a1-407f-87ec-9a4e7e78960b',
  },
};

export default mockMap;
